<div class="pagecontent">
    <form [formGroup]="agentTripRequestForm">
        <mat-horizontal-stepper animationDuration="0ms" #stepper >
            <mat-step>
                <app-consumer-details></app-consumer-details>
                <div class="consumer-button">
                    <button type="button" mat-button (click)="goToTripEntry(stepper, 'Next')">Start</button>
                </div>               
            </mat-step>
            <mat-step>
                <app-trip-details></app-trip-details>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToConsumerDetails(stepper)">Back</button></div>
                    <div class="right-button">
                        <button type="button"  mat-button (click)="goToSummary(stepper)">Next</button>
                    </div>                   
                </div>
            </mat-step>
            <mat-step>
                <app-agent-trip-summary></app-agent-trip-summary>
                <div class="button-container">
                    <div class="left-button">
                        <button type="button"  mat-button (click)="goToTripEntry(stepper, 'Back')">Back</button></div>
                    <div class="right-button">
                        <button type="submit"  mat-button (click)="saveTripRequest()">Submit</button>
                    </div>                   
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </form>
</div>

<ng-template #confirmationDialogTemplate>
  <div class="access-dialogue">
    <h2 mat-dialog-title class="dialog-title-center">{{dialogTitle}}</h2>
    <mat-dialog-content>
      <p>{{dialogContent}}</p>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions-center">
      <button mat-flat-button color="primary" (click)="closeDialog()">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>